module.exports = window.wp.coreData;